module.exports = __webpack_public_path__ + "img/landingpage-bg3.6f46ce40.png";